<template>
  <div class="mt-2">
    <div v-if="product">
      <v-layout>
        <v-flex>
          <v-btn flat @click="cancelContent">
            <i class="fas fa-chevron-left mr-1"></i>
            {{ $t('Back') }}
          </v-btn>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn depressed color="primary" @click="saveProduct">{{ $t('Save') }}</v-btn>
        </v-flex>
      </v-layout>

      <h3 class="headline mt-3">{{ $t('Edit Product') }}</h3>

      <div class="form-control mt-3" :class="{ 'has-error': errors.has('categoryInput') }">
        <label class="caption" for="categoryInput">{{ $t('Category') }} *</label>
        <select-category
          :pageid="pageid"
          v-model="category"
          :selected="currentCategory"
          @onChangeCategory="onChangeCategory"
          data-vv-name="categoryInput"
          :data-vv-as="$t('Category')"
          v-validate="'required'"
        ></select-category>
        <p
          class="text-error"
          v-show="errors.has('categoryInput')"
        >{{ errors.first('categoryInput') }}</p>
      </div>

      <div class="pb-3 form-control" :class="{ 'has-error': errors.has('uploadMultipleFile') }">
        <upload-multiple-file
          v-model="productImages"
          :max="10"
          data-vv-name="uploadMultipleFile"
          data-vv-as="Preview Image"
        ></upload-multiple-file>

        <span class="text-error" v-show="errors.has('uploadMultipleFile')">
          {{
          errors.first('uploadMultipleFile')
          }}
        </span>
      </div>

      <div class="form-control" :class="{ 'has-error': errors.has('nameInput') }">
        <label class="caption" for="nameInput">{{ $t('Product Name') }} *</label>
        <input
          type="text"
          class="form-control"
          ref="name"
          id="nameInput"
          name="nameInput"
          :data-vv-as="$t('Product Name')"
          aria-describedby="name"
          :placeholder="$t('Product Name')"
          v-model="product.name"
          v-validate="'required'"
        />
        <span class="text-error" v-show="errors.has('nameInput')">
          {{
          errors.first('nameInput')
          }}
        </span>
      </div>

      <div class="form-control" :class="{ 'has-error': errors.has('descriptionInput') }">
        <div>
          <label class="caption" for="nameInput">{{ $t('Product detail') }} *</label>
        </div>
        <textarea
          type="text"
          class="form-control"
          id="descriptionInput"
          style="resize:vertical;min-height: 90px;width: 100%"
          name="descriptionInput"
          :data-vv-as="$t('Product detail')"
          aria-describedby="description"
          :placeholder="$t('Product detail')"
          row="3"
          v-model="product.description"
          v-validate="'required'"
        ></textarea>
        <span class="text-error" v-show="errors.has('descriptionInput')">
          {{
          errors.first('descriptionInput')
          }}
        </span>
      </div>

      <v-layout wrap>
        <v-flex xs-12 sm-6 class="form-control px-1">
          <div>
            <label for="effectiveDateInput" class="caption">{{$t('Effective Date')}}</label>
          </div>
          <v-menu
            ref="showEffectiveDate"
            v-model="showEffectiveDate"
            :close-on-content-click="false"
            full-width
            max-width="290px"
            color="primary"
          >
            <template v-slot:activator="{ on }">
              <v-layout>
                <v-flex>
                  <input type="text" name id v-model="effectivedate" v-on="on" readonly />
                </v-flex>
                <v-flex>
                  <v-btn fab flat small class="my-0" @click="effectivedate = null">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </template>
            <v-date-picker
              color="primary"
              v-model="effectivedate"
              @input="showEffectiveDate = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs-12 sm-6 class="form-control px-1">
          <div>
            <label for="effectiveDateInput" class="caption">{{$t('End Date')}}</label>
          </div>
          <v-menu
            ref="showEndDate"
            v-model="showEndDate"
            :close-on-content-click="false"
            full-width
            max-width="290px"
            color="primary"
          >
            <template v-slot:activator="{ on }">
              <v-layout>
                <v-flex>
                  <input type="text" name id v-model="enddate" v-on="on" readonly />
                </v-flex>
                <v-flex>
                  <v-btn fab flat small class="my-0" @click="enddate = null">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </template>
            <v-date-picker color="primary" v-model="enddate" @input="showEndDate = false"></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>

      <template v-if="$store.state.specialpage.includes(selectedBot.pageid)">
        <div class="hr" style="margin-top: 35px;"></div>
        <template v-if="$store.getters.getPackage == 'premium'">
          <div class="text-xs-center" style="margin-top: -15px;">
            <a
              class="btn-advanced"
              href="javascript:void(0);"
              @click="showAdvanced = !showAdvanced"
            >
              {{ $t('Advanced') }}
              <i
                class="fa"
                :class="{ 'fa-angle-down': showAdvanced, 'fa-angle-up': !showAdvanced }"
              ></i>
            </a>
          </div>

          <template v-if="showAdvanced">
            <div class="row form-control" :class="{ 'has-error': errorTag.length > 0 }">
              <div class="col s12">
                <label class="caption" for="keywordInput">{{ $t('Keywords') }}</label>
                <tags
                  v-model="tag"
                  :tags="tags"
                  @tags-changed="newTags => (tags = newTags)"
                  @before-adding-tag="checkTag"
                />
                <span class="text-error" v-if="errorTag.length > 0">
                  <template v-if="errorTag.includes('duplicate')">
                    {{
                    $t('Duplicate Choice')
                    }}
                  </template>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col s12 m6">
                <div
                  class="form-control"
                  v-if="product.buttonaction == 'url' || product.buttonaction == 'buy'"
                >
                  <label class="caption" for="buttonNameInput">{{ $t('Button Name') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="buttonNameInput"
                    aria-describedby="Button Name"
                    :placeholder="$t('Button Name')"
                    v-model="product.buttonname"
                  />
                </div>
              </div>
              <div class="col s12 m6">
                <div class="form-control" v-if="product.buttonaction == 'url'">
                  <label class="caption" for="buttonUrlInput">{{ $t('Product Url') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="buttonUrlInput"
                    aria-describedby="Product Url"
                    :placeholder="$t('Product Url')"
                    v-model="product.buttonurl"
                  />
                </div>
              </div>
            </div>
          </template>
        </template>
      </template>

      <div class="text-xs-center mt-4">
        <v-btn color="grey" outline @click="cancelContent()">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" depressed @click="saveProduct">{{ $t('Save') }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import SelectCategory from './SelectCategory'
import uploadfile from '@/components/elements/uploadfile'
import api from '@/api'
import VueTagsInput from '@johmun/vue-tags-input'
import UploadMultipleFile from '@/components/elements/UploadMultipleFile'
import ProductStock from './ProductStock'
import ProductBundle from './ProductBundle'
import Tags from '@/components/elements/Tags'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  props: ['value', 'category'],
  inject: ['$validator'],
  data: function() {
    return {
      productImages: [],
      showEffectiveDate: false,
      showEndDate: false,
      product: null,
      currentCategory: this.value.categoryid,
      categories: null,
      tag: '',
      currentView: 'product',
      showAdvanced: false,
      deleteStockList: [],
      deleteBundleList: [],
      productstock: [],
      productbundle: [],

      loadingStock: null,
      loadingBundle: null,
      stock_process_count: 0,
      bundle_process_count: 0,

      isLoadingBundle: true,

      errorTag: [],
      effectivedate: null,
      enddate: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    currencySign: function() {
      if (this.product && this.product.currency) {
        switch (this.product.currency.toUpperCase()) {
          case 'THB':
            return '฿'
          case 'MMK':
            return 'K'

          default:
            return '$'
        }
      }
      return '$'
    },
    pageid: function() {
      return this.$store.state.selectedBot.pageid
    },
    tags: {
      get() {
        let vm = this
        if (vm.product.keyword != '') {
          var tags = vm.product.keyword.split(',')
          var result = []
          $.each(tags, function(index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function(index, val) {
          result.push(val.text)
        })
        vm.product.keyword = result.join(',')
      }
    }
  },
  components: {
    SelectCategory,
    uploadfile: uploadfile,
    VueTagsInput,
    UploadMultipleFile,
    ProductStock,
    ProductBundle,
    Tags
  },
  mounted: function() {
    let vm = this
    vm.product = JSON.parse(JSON.stringify(vm.value))
    vm.product.buttonaction = 'url'
    vm.cached_product = JSON.stringify(vm.product)
    vm.effectivedate = vm.product.effectivedate
      ? moment(vm.product.effectivedate).format('YYYY-MM-DD')
      : null
    vm.enddate = vm.product.enddate ? moment(vm.product.enddate).format('YYYY-MM-DD') : null

    vm.productstock = []
    $.each(vm.value.productstock, function(index, val) {
      vm.productstock.push(JSON.parse(JSON.stringify(val)))
    })

    vm.cached_productstock = JSON.stringify(vm.value.productstock)

    vm.productImages = vm.product.photourl.split(';;')

    if (vm.productImages.length > 0) {
      vm.productImages.map(function(val, index) {
        if (val == '') {
          vm.productImages.splice(index, 1)
        }
      })
    }
    vm.currentCategory = vm.product.categoryid
    // vm.$refs.name.focus();

    vm.isLoadingBundle = true
    vm.getProductBundle(function(data) {
      vm.productbundle = data
      vm.isLoadingBundle = false
    })

    document.addEventListener('keydown', e => {
      if (e.keyCode == 27) {
        vm.$emit('close')
      }
    })
  },
  methods: {
    getProductBundle: function(callback) {
      let vm = this
      var data = {
        id: vm.product.id
      }

      api.getProductBundle(data, function(error, response) {
        if (error) {
          console.error(error)
          callback([])
          return
        }

        callback(response.productbundlelist)
      })
    },
    onChangeCategory: function(payload) {
      this.currentCategory = payload
    },
    saveProduct: function() {
      let vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()

          return false
        }
        let product = Object.assign({}, vm.product)

        product.productstock = []
        $.each(vm.productstock, function(index, val) {
          product.productstock.push(Object.assign([], val))
        })

        product.price = parseFloat(product.price)
        product.discountprice = parseFloat(product.discountprice)
        product.pageid = vm.pageid
        product.photourl = vm.productImages.join(';;')
        product.categoryid = vm.currentCategory

        product.effectivedate = vm.effectivedate ? moment(vm.effectivedate).format() : null
        product.enddate = vm.enddate ? moment(vm.enddate).format() : null

        vm.$store.dispatch('loading')
        api.editProduct(product, function(error, response) {
          // vm.saveStock(function() {
          //   if (vm.$store.getters.getPackage === 'premium') {
          //     vm.saveBundle(function() {
          //       vm.completeSaveProduct(product)
          //     })
          //   } else {
          //     vm.completeSaveProduct(product)
          //   }
          // })
          vm.completeSaveProduct(product)
        })
      })
    },
    completeSaveProduct: function(product) {
      this.cached_product = JSON.stringify(product)
      this.cached_productstock = JSON.stringify(this.productstock)

      this.$emit('input', product)
      this.$emit('onSaveProduct')
    },
    saveStock: function(callback) {
      let vm = this

      let productstock = []

      vm.stock_process_count = vm.productstock.length + vm.deleteStockList.length

      $.each(vm.productstock, function(index, value) {
        let stock = {
          id: value[0],
          option: value[1],
          productid: vm.product.id,
          quantity: value[2],
          sku: value[5],
          orders: value[6]
        }

        if (value[3] == '' || parseFloat(value[3]) == 0) {
          stock.price = null
        } else {
          stock.price = value[3]
        }

        if (value[4] == '' || parseFloat(value[4]) == 0) {
          stock.discountprice = null
        } else {
          stock.discountprice = value[4]
        }

        if (value[0] == null) {
          api.saveProductStock(stock, function(error, response) {
            if (error) {
              console.error(error)
            }
            vm.productstock[index][0] = response.productstockid
            vm.stock_process_count--
          })
        } else {
          api.editProductStock(stock, function(error, response) {
            if (error) {
              console.error(error)
            }
            vm.stock_process_count--
          })
        }
      })

      $.each(vm.deleteStockList, function(index, val) {
        api.deleteProductStock(val, function(error, response) {
          if (error) {
            console.error(error)
          }
          vm.stock_process_count--
        })
      })

      vm.loadingStock = setInterval(function() {
        if (vm.stock_process_count == 0) {
          if (vm.loadingStock) {
            clearInterval(vm.loadingStock)
          }
          callback()
        }
      }, 1000)
    },
    saveBundle: function(callback) {
      let vm = this

      let productbundle = []

      vm.bundle_process_count = vm.productbundle.length + vm.deleteBundleList.length

      $.each(vm.productbundle, function(index, value) {
        let bundle = value
        bundle.productid = vm.product.id

        if (bundle.id == null) {
          api.saveProductBundle(bundle, function(error, response) {
            if (error) {
              console.error(error)
            }
            vm.productbundle[index].id = response.productbundleid
            vm.bundle_process_count--
          })
        } else {
          api.editProductBundle(bundle, function(error, response) {
            if (error) {
              console.error(error)
            }
            vm.bundle_process_count--
          })
        }
      })

      $.each(vm.deleteBundleList, function(index, val) {
        api.deleteProductBundle(val, function(error, response) {
          if (error) {
            console.error(error)
          }
          vm.bundle_process_count--
        })
      })

      vm.loadingBundle = setInterval(function() {
        if (vm.bundle_process_count == 0) {
          if (vm.loadingBundle) {
            clearInterval(vm.loadingBundle)
          }
          callback()
        }
      }, 1000)
    },
    deleteStock: function(id) {
      this.deleteStockList.push(id)
    },
    deleteBundle: function(id) {
      this.deleteBundleList.push(id)
    },
    checkTag: function(obj) {
      this.errorTag = []
      if (this.tags.map(t => t.text).indexOf(obj.tag.text) !== -1) {
        this.errorTag.push('duplicate')
      } else obj.addTag()
    },
    onDeleteProduct: function(id) {
      if (confirm('Do you want to delete this?')) {
        let vm = this
        vm.$store.dispatch('loading')
        api.deleteProduct(id, function(error, response) {
          if (error) {
            vm.$store.dispatch('loading')
            console.error(error)
            return
          }

          vm.$emit('productDeleted')
          vm.$emit('close')
          vm.$store.dispatch('loading')
        })
      }
    },
    cancelContent: function() {
      var vm = this
      vm.product = JSON.parse(vm.cached_product)
      vm.productstock = JSON.parse(vm.cached_productstock)
      vm.productImages = vm.product.photourl.split(';;')

      vm.$emit('close')
    },
    onChangePrice: function() {
      this.product.discountprice = this.product.price
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      let vm = this
      vm.product = JSON.parse(JSON.stringify(vm.value))
      vm.product.buttonaction = 'url'
      vm.cached_product = JSON.stringify(vm.product)
      vm.effectivedate = vm.product.effectivedate
        ? moment(vm.product.effectivedate).format('YYYY-MM-DD')
        : null
      vm.enddate = vm.product.enddate ? moment(vm.product.enddate).format('YYYY-MM-DD') : null

      vm.productstock = []
      $.each(vm.value.productstock, function(index, val) {
        vm.productstock.push(JSON.parse(JSON.stringify(val)))
      })

      vm.cached_productstock = JSON.stringify(vm.value.productstock)
      vm.currentCategory = vm.product.categoryid

      vm.productImages = vm.product.photourl.split(';;')

      vm.isLoadingBundle = true
      vm.getProductBundle(function(data) {
        vm.productbundle = data
        vm.isLoadingBundle = false
      })
    }
  }
}
</script>

<style scroped></style>



// WEBPACK FOOTER //
// src/components/view/template/ananda/ModalEditProduct.vue